import { render, staticRenderFns } from "./BenefitEvents.vue?vue&type=template&id=11e89aef&scoped=true&"
import script from "./BenefitEvents.vue?vue&type=script&lang=js&"
export * from "./BenefitEvents.vue?vue&type=script&lang=js&"
import style0 from "./BenefitEvents.vue?vue&type=style&index=0&id=11e89aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e89aef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCol,VDataTable,VForm,VRow,VSimpleCheckbox})
